import { userDataFormatted } from '@/js/utils';

const SET_USER_DATA = (state, userInfo) => {
  const {
    profilePic,
    userName,
    userEmail,
    timezoneOffset,
    /* googleScope, */ language,
    theme,
    desktopTheme,
    mobileTheme,
    userPreferences,
    soundId,
    maxConn,
    dataStorage,
    downloadTopic,
    systemTime,
    notificationEmail,
    pendingNotificationEmail,
    encodingType,
  } = userDataFormatted(userInfo);
  state.profilePic = profilePic;
  state.userName = userName;
  state.userEmail = userEmail;
  state.timezoneOffset = timezoneOffset;
  state.language = language;
  // state.googleScope = googleScope;
  state.theme = theme;
  state.mobileTheme = mobileTheme;
  state.desktopTheme = desktopTheme;
  state.userPreferences = userPreferences;
  state.soundId = soundId;
  state.maxConn = maxConn;
  state.dataStorage = dataStorage;
  state.downloadTopic = downloadTopic;
  state.systemTime = systemTime;
  state.notiEmail = notificationEmail;
  state.pendingNotiEmail = pendingNotificationEmail;
  state.encodingType = encodingType;
};

const SET_PROMISE = (state, promise) => {
  state.promise = promise;
};

const SET_ANNOUNCEMENT_LIST = (state, list) => {
  state.announcementList = list.sort((a, b) => b.time_start - a.time_start);
};

export default {
  SET_USER_DATA,
  SET_PROMISE,
  SET_ANNOUNCEMENT_LIST,
};
